
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.7.1
 * Query Engine version: 0ca5ccbcfa6bdc81c003cf549abe4269f59c41e5
 */
Prisma.prismaVersion = {
  client: "5.7.1",
  engine: "0ca5ccbcfa6bdc81c003cf549abe4269f59c41e5"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  loginType: 'loginType',
  walletAddress: 'walletAddress',
  deletedWalletAddress: 'deletedWalletAddress',
  lastLoginAt: 'lastLoginAt',
  nickname: 'nickname',
  imageUrl: 'imageUrl',
  isAgreedPrivacy: 'isAgreedPrivacy',
  isAgreedTerms: 'isAgreedTerms',
  isAgreedMarketing: 'isAgreedMarketing',
  isSignInCompleted: 'isSignInCompleted',
  myFandomIds: 'myFandomIds',
  countryId: 'countryId',
  fandomId: 'fandomId'
};

exports.Prisma.AdminScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  password: 'password',
  name: 'name'
};

exports.Prisma.Web3TransactionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chainId: 'chainId',
  status: 'status',
  transactionHash: 'transactionHash',
  confirmations: 'confirmations',
  blockHash: 'blockHash',
  blockNumber: 'blockNumber',
  error: 'error'
};

exports.Prisma.Web3TransactionQueueScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chainId: 'chainId',
  status: 'status',
  transactionHash: 'transactionHash',
  from: 'from',
  to: 'to',
  data: 'data',
  value: 'value',
  gasLimit: 'gasLimit',
  gasPrice: 'gasPrice',
  maxPriorityFeePerGas: 'maxPriorityFeePerGas',
  maxFeePerGas: 'maxFeePerGas',
  nonce: 'nonce',
  error: 'error',
  web3TransactionId: 'web3TransactionId'
};

exports.Prisma.Web3DepositTransactionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chainId: 'chainId',
  status: 'status',
  transactionHash: 'transactionHash',
  web3TransactionId: 'web3TransactionId',
  userId: 'userId'
};

exports.Prisma.PointTransactionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  amount: 'amount',
  balance: 'balance',
  type: 'type',
  refTable: 'refTable',
  refId: 'refId',
  comment: 'comment',
  userId: 'userId'
};

exports.Prisma.UserDailyPointScalarFieldEnum = {
  id: 'id',
  earnDate: 'earnDate',
  point: 'point',
  userId: 'userId'
};

exports.Prisma.FeedScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  title: 'title',
  content: 'content',
  voteOpenAt: 'voteOpenAt',
  voteDeletedAt: 'voteDeletedAt',
  voteIsVisible: 'voteIsVisible',
  score: 'score',
  isVisible: 'isVisible',
  totalLikeCount: 'totalLikeCount',
  totalCommentCount: 'totalCommentCount',
  userId: 'userId',
  fandomId: 'fandomId',
  voteId: 'voteId',
  feedCategoryId: 'feedCategoryId'
};

exports.Prisma.FeedCategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title'
};

exports.Prisma.CommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  content: 'content',
  totalLikeCount: 'totalLikeCount',
  userId: 'userId',
  feedId: 'feedId',
  parentId: 'parentId',
  voteId: 'voteId'
};

exports.Prisma.FileScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  url: 'url',
  thumbnailUrl: 'thumbnailUrl',
  fileType: 'fileType',
  feedId: 'feedId',
  voteId: 'voteId'
};

exports.Prisma.CountryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  code: 'code',
  isoCode: 'isoCode'
};

exports.Prisma.FandomScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  title: 'title',
  description: 'description',
  imageUrl: 'imageUrl',
  isVisible: 'isVisible',
  totalUserCount: 'totalUserCount',
  totalFeedCount: 'totalFeedCount',
  clubContractId: 'clubContractId'
};

exports.Prisma.VoteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  title: 'title',
  description: 'description',
  openAt: 'openAt',
  startAt: 'startAt',
  endAt: 'endAt',
  resultAt: 'resultAt',
  imageUrl: 'imageUrl',
  pointPerVote: 'pointPerVote',
  isVisible: 'isVisible',
  hasEtcOption: 'hasEtcOption',
  totalCommentCount: 'totalCommentCount',
  totalVotedPoint: 'totalVotedPoint',
  voteCategoryId: 'voteCategoryId',
  fandomId: 'fandomId',
  userId: 'userId'
};

exports.Prisma.VoteCategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  types: 'types'
};

exports.Prisma.VoteItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  title: 'title',
  description: 'description',
  imageUrl: 'imageUrl',
  type: 'type',
  totalVotedPoint: 'totalVotedPoint',
  voteId: 'voteId'
};

exports.Prisma.User_FandomScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isJoined: 'isJoined',
  userId: 'userId',
  fandomId: 'fandomId'
};

exports.Prisma.Feed_User_LikeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isLiked: 'isLiked',
  feedId: 'feedId',
  userId: 'userId'
};

exports.Prisma.Comment_User_LikeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isLiked: 'isLiked',
  commentId: 'commentId',
  userId: 'userId'
};

exports.Prisma.Web3NetworkScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chainId: 'chainId',
  dpAddress: 'dpAddress',
  rpcUrl: 'rpcUrl',
  archiveNodeUrl: 'archiveNodeUrl'
};

exports.Prisma.Web3NetworkPrivateKeyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chainId: 'chainId',
  privateKey: 'privateKey'
};

exports.Prisma.Web3StakingPoolQueueScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chainId: 'chainId',
  transactionHash: 'transactionHash',
  web3TransactionId: 'web3TransactionId'
};

exports.Prisma.HomeBannerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  description: 'description',
  startAt: 'startAt',
  endAt: 'endAt',
  priority: 'priority',
  linkUrl: 'linkUrl',
  imageUrl: 'imageUrl',
  isVisible: 'isVisible'
};

exports.Prisma.ClubContractScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chainId: 'chainId',
  contractAddress: 'contractAddress',
  factoryAddress: 'factoryAddress',
  implementationAddress: 'implementationAddress',
  ownerAddress: 'ownerAddress',
  isAssigned: 'isAssigned'
};

exports.Prisma.ClubStakingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chainId: 'chainId',
  settlementDate: 'settlementDate',
  stakingAddress: 'stakingAddress',
  userAddress: 'userAddress',
  amount: 'amount',
  blockNumber: 'blockNumber',
  clubContractId: 'clubContractId',
  isSettled: 'isSettled'
};

exports.Prisma.ClubRewardTransactionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  userAddress: 'userAddress',
  amount: 'amount',
  totalAmount: 'totalAmount',
  userId: 'userId',
  clubContractId: 'clubContractId'
};

exports.Prisma.SendingTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  network: 'network',
  chainId: 'chainId',
  contractAddress: 'contractAddress'
};

exports.Prisma.TokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  network: 'network',
  chainId: 'chainId',
  symbol: 'symbol',
  contractAddress: 'contractAddress',
  name: 'name',
  decimals: 'decimals',
  isNative: 'isNative'
};

exports.Prisma.TokenPriceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  symbol: 'symbol',
  price: 'price',
  source: 'source'
};

exports.Prisma.TokenHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  txTimestamp: 'txTimestamp',
  type: 'type',
  status: 'status',
  walletAddress: 'walletAddress',
  chainId: 'chainId',
  amount: 'amount',
  toAddress: 'toAddress',
  transactionHash: 'transactionHash',
  blockNumber: 'blockNumber',
  usedGasFee: 'usedGasFee',
  gasFeeSymbol: 'gasFeeSymbol',
  errorReason: 'errorReason',
  refTable: 'refTable',
  refId: 'refId',
  spendPoint: 'spendPoint',
  unstakingAmount: 'unstakingAmount',
  receivePoint: 'receivePoint',
  userOpHash: 'userOpHash',
  tokenId: 'tokenId',
  userId: 'userId'
};

exports.Prisma.ConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  value: 'value'
};

exports.Prisma.ConfigHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  key: 'key',
  value: 'value',
  adminName: 'adminName'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.LoginType = exports.$Enums.LoginType = {
  WEB3_AUTH: 'WEB3_AUTH',
  WEB3_MODAL: 'WEB3_MODAL'
};

exports.Web3TransactionStatus = exports.$Enums.Web3TransactionStatus = {
  PENDING: 'PENDING',
  CONFIRMING: 'CONFIRMING',
  SUCCEED: 'SUCCEED',
  FAILED: 'FAILED'
};

exports.Web3TransactionQueueStatus = exports.$Enums.Web3TransactionQueueStatus = {
  PENDING: 'PENDING',
  SENDING: 'SENDING',
  SUCCEED: 'SUCCEED',
  FAILED: 'FAILED'
};

exports.Web3DepositTransactionStatus = exports.$Enums.Web3DepositTransactionStatus = {
  PENDING: 'PENDING',
  CONFIRMING: 'CONFIRMING',
  SUCCEED: 'SUCCEED',
  FAILED: 'FAILED'
};

exports.PointTransactionType = exports.$Enums.PointTransactionType = {
  ADMIN: 'ADMIN',
  SIGN_IN: 'SIGN_IN',
  FEED: 'FEED',
  LIKE_ON_MY_FEED: 'LIKE_ON_MY_FEED',
  COMMENT_ON_MY_FEED: 'COMMENT_ON_MY_FEED',
  REPLY_ON_MY_FEED: 'REPLY_ON_MY_FEED',
  COMMENT: 'COMMENT',
  VOTE_CREATE: 'VOTE_CREATE',
  VOTE: 'VOTE',
  LIKE_FEED: 'LIKE_FEED',
  LIKE_COMMENT: 'LIKE_COMMENT',
  STAKING_REWARD: 'STAKING_REWARD',
  FIRST_LIKE_FEED: 'FIRST_LIKE_FEED',
  FIRST_COMMENT: 'FIRST_COMMENT',
  FIRST_REPLY: 'FIRST_REPLY',
  FIRST_SHARE: 'FIRST_SHARE',
  FIRST_EVENT_ENTER: 'FIRST_EVENT_ENTER',
  FIRST_EVENT_SHARE: 'FIRST_EVENT_SHARE',
  SWAP: 'SWAP',
  SWAP_CANCEL: 'SWAP_CANCEL'
};

exports.FeedCategoryTitle = exports.$Enums.FeedCategoryTitle = {
  NORMAL: 'NORMAL',
  ETC: 'ETC'
};

exports.FileType = exports.$Enums.FileType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  PDF: 'PDF',
  OTHER: 'OTHER'
};

exports.VoteItemType = exports.$Enums.VoteItemType = {
  NORMAL: 'NORMAL',
  ETC: 'ETC'
};

exports.ClubRewardTransactionType = exports.$Enums.ClubRewardTransactionType = {
  STAKING: 'STAKING'
};

exports.TokenHistoryType = exports.$Enums.TokenHistoryType = {
  DEPOSIT: 'DEPOSIT',
  WITHDRAW: 'WITHDRAW',
  TRANSFER: 'TRANSFER',
  STAKING: 'STAKING',
  REQ_UNSTAKING: 'REQ_UNSTAKING',
  RET_REWARD: 'RET_REWARD',
  CANCEL_UNSTAKING: 'CANCEL_UNSTAKING',
  INSTANT_UNSTAKING: 'INSTANT_UNSTAKING'
};

exports.Prisma.ModelName = {
  User: 'User',
  Admin: 'Admin',
  Web3Transaction: 'Web3Transaction',
  Web3TransactionQueue: 'Web3TransactionQueue',
  Web3DepositTransaction: 'Web3DepositTransaction',
  PointTransaction: 'PointTransaction',
  UserDailyPoint: 'UserDailyPoint',
  Feed: 'Feed',
  FeedCategory: 'FeedCategory',
  Comment: 'Comment',
  File: 'File',
  Country: 'Country',
  Fandom: 'Fandom',
  Vote: 'Vote',
  VoteCategory: 'VoteCategory',
  VoteItem: 'VoteItem',
  User_Fandom: 'User_Fandom',
  Feed_User_Like: 'Feed_User_Like',
  Comment_User_Like: 'Comment_User_Like',
  Web3Network: 'Web3Network',
  Web3NetworkPrivateKey: 'Web3NetworkPrivateKey',
  Web3StakingPoolQueue: 'Web3StakingPoolQueue',
  HomeBanner: 'HomeBanner',
  ClubContract: 'ClubContract',
  ClubStaking: 'ClubStaking',
  ClubRewardTransaction: 'ClubRewardTransaction',
  SendingToken: 'SendingToken',
  Token: 'Token',
  TokenPrice: 'TokenPrice',
  TokenHistory: 'TokenHistory',
  Config: 'Config',
  ConfigHistory: 'ConfigHistory'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
